import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup.object({
    insightStatus: yup.string().required(
      formatMessage({
        id: 'SETTINGS_INSIGHT_METHOD_IS_REQUIRED',
        defaultMessage: 'Status is required',
      }),
    ),
  });

export default validationSchema;
